import {
  STATE_TOKEN_OPERATOR,
  STATE_TOKEN_OPERATOR_ACTIVE,
} from './token_operator_modal_controller';
import {
  STATE_TOKEN_TYPE,
  STATE_TOKEN_TYPE_ACTIVE,
} from './token_type_modal_controller';
import {
  STATE_TOKEN_VALUE,
  STATE_TOKEN_VALUE_ACTIVE,
} from './token_value_modal_controller';

export {
  STATE_TOKEN_OPERATOR,
  STATE_TOKEN_OPERATOR_ACTIVE,
  STATE_TOKEN_TYPE,
  STATE_TOKEN_TYPE_ACTIVE,
  STATE_TOKEN_VALUE,
  STATE_TOKEN_VALUE_ACTIVE,
};

export const STATE_BLURRED = 'blurred';
export const STATES = [
  STATE_BLURRED,
  STATE_TOKEN_TYPE,
  STATE_TOKEN_TYPE_ACTIVE,
  STATE_TOKEN_OPERATOR,
  STATE_TOKEN_OPERATOR_ACTIVE,
  STATE_TOKEN_VALUE,
  STATE_TOKEN_VALUE_ACTIVE,
] as const;

export type SearchBarState = (typeof STATES)[number];
